export default __webpack_public_path__ + "static/media/success2.png";